import { z } from 'zod'

export const newsSchema = z.object({
  /** 最新消息Id */
  id: z.number(),
  /** 圖片資訊 */
  fileGuid: z.string(),
  /** 標題 */
  subject: z.string(),
  /** 內容 */
  content: z.string(),
  /** 發佈日期 */
  releaseDate: z.string()
})

export interface News extends z.infer<typeof newsSchema> {}

export class News {
  constructor() {
    return {
      id: 0,
      fileGuid: '',
      subject: '',
      content: '',
      releaseDate: ''
    }
  }
}
